export enum ChatMessageSender {
  user = "user",
  ai = "ai",
}

export interface ChatMessage {
  message: string
  sentAt: Date
  sender: ChatMessageSender
  hidden?: boolean
}

export interface Call {
  id: string
  agentId?: string
  chatMessages: ChatMessage[]
  leftAt?: Date | string
  startedAt: Date | string
  endedAt?: Date
  rating?: number
  feedback?: string
  creatorId?: string
  callDuration?: number
  sendTranscriptToUser?: boolean | false
}

export enum ChatMessageInputType {
  text = "text",
  voice = "voice",
}

export interface RoomLoader {
  matchedElement: Call
}

export type TCallDisconnect = { reason: string; description: string }

export enum CallDisconnectType {
  SessionExpired = "Session Expired",
  CreditsExhausted = "Credits Exhausted",
  InActive = "In Active",
  Other = "Other",
}

export const CallDisconnect: Record<CallDisconnectType, TCallDisconnect> = {
  [CallDisconnectType.SessionExpired]: {
    reason: "Session Expired",
    description:
      "Your session has reached its maximum allowed duration. Please start a new call to continue.",
  },
  [CallDisconnectType.CreditsExhausted]: {
    reason: "Credits Exhausted",
    description:
      "The account associated with this agent has inactive subscription or ran out of credits.",
  },
  [CallDisconnectType.InActive]: {
    reason: "Your Call is ended due to inactivity",
    description:
      "It looks like you haven't been active for the past 2 minutes. Click 'Start Conversation' to join the new call.",
  },
  [CallDisconnectType.Other]: {
    reason: "Something went wrong",
    description: "Please try again",
  },
}
